import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/vercel/path0/node_modules/gatsby-theme-docz/src/base/Layout.js";
import StackedBarChart from '../core/StackedBarChart';
import { Playground } from 'docz';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h1 {...{
      "id": "demo"
    }}>{`Demo`}</h1>
    <h2 {...{
      "id": "chart-with-2-bars-stacked-and-a-line-on-top"
    }}>{`Chart with 2 bars stacked and a line on top`}</h2>
    <Playground __position={0} __code={'<StackedBarChart\n  xType=\"time\"\n  yComplement={value => `R$ ${value},00`}\n  title=\"iOS\"\n  toolboxTooltip={{ saveAsImage: \'save\' }}\n  colors={[\'#30D2D6\', \'#9F88FB\', \'#F09B1B\']}\n  tooltip={{\n    label: \'Período\',\n    topResult: \'Preventivas\',\n    bottomResult: \'Corretivas\',\n    lineResult: \'Total\',\n  }}\n  data={[\n    [\n      { label: \'2019-01-01\', result: 1 },\n      { label: \'2019-02-01\', result: 2 },\n      { label: \'2019-03-01\', result: 4 },\n      { label: \'2019-04-01\', result: 5 },\n      { label: \'2019-05-01\', result: 6 },\n      { label: \'2019-06-01\', result: 7 },\n    ],\n    [\n      { label: \'2019-01-01\', result: 10 },\n      { label: \'2019-02-01\', result: 40 },\n      { label: \'2019-03-01\', result: 30 },\n      { label: \'2019-04-01\', result: 20 },\n      { label: \'2019-05-01\', result: 40 },\n      { label: \'2019-06-01\', result: 50 },\n    ],\n    [\n      { label: \'2019-01-01\', result: 11 },\n      { label: \'2019-02-01\', result: 42 },\n      { label: \'2019-03-01\', result: 54 },\n      { label: \'2019-04-01\', result: 55 },\n      { label: \'2019-05-01\', result: 66 },\n      { label: \'2019-06-01\', result: 87 },\n    ],\n  ]}\n/>'} __scope={{
      props,
      DefaultLayout,
      StackedBarChart,
      Playground,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
    <StackedBarChart xType='time' yComplement={value => `R$ ${value},00`} title='iOS' toolboxTooltip={{
        saveAsImage: 'save'
      }} colors={['#30D2D6', '#9F88FB', '#F09B1B']} tooltip={{
        label: 'Período',
        topResult: 'Preventivas',
        bottomResult: 'Corretivas',
        lineResult: 'Total'
      }} data={[[{
        label: '2019-01-01',
        result: 1
      }, {
        label: '2019-02-01',
        result: 2
      }, {
        label: '2019-03-01',
        result: 4
      }, {
        label: '2019-04-01',
        result: 5
      }, {
        label: '2019-05-01',
        result: 6
      }, {
        label: '2019-06-01',
        result: 7
      }], [{
        label: '2019-01-01',
        result: 10
      }, {
        label: '2019-02-01',
        result: 40
      }, {
        label: '2019-03-01',
        result: 30
      }, {
        label: '2019-04-01',
        result: 20
      }, {
        label: '2019-05-01',
        result: 40
      }, {
        label: '2019-06-01',
        result: 50
      }], [{
        label: '2019-01-01',
        result: 11
      }, {
        label: '2019-02-01',
        result: 42
      }, {
        label: '2019-03-01',
        result: 54
      }, {
        label: '2019-04-01',
        result: 55
      }, {
        label: '2019-05-01',
        result: 66
      }, {
        label: '2019-06-01',
        result: 87
      }]]} mdxType="StackedBarChart" />
    </Playground>
    <h1 {...{
      "id": "chart-with-3-bars-stacked-and-a-line-on-top"
    }}>{`Chart with 3 bars stacked and a line on top`}</h1>
    <Playground __position={1} __code={'<StackedBarChart\n  xType=\"time\"\n  yComplement={value => `R$ ${value},00`}\n  title=\"Custo por manutenção\"\n  toolboxTooltip={{ saveAsImage: \'save\' }}\n  colors={[\'#30D2D6\', \'#9F88FB\', \'#C5F3C2\', \'#F09B1B\']}\n  tooltip={{\n    label: \'Período\',\n    topResult: \'Preventivas\',\n    bottomResult: \'Corretivas\',\n    extraResult: \'Melhorias\',\n    lineResult: \'Total\',\n  }}\n  data={[\n    [\n      { label: \'2019-01-01\', result: 1 },\n      { label: \'2019-02-01\', result: 2 },\n      { label: \'2019-03-01\', result: 4 },\n      { label: \'2019-04-01\', result: 5 },\n      { label: \'2019-05-01\', result: 6 },\n      { label: \'2019-06-01\', result: 7 },\n    ],\n    [\n      { label: \'2019-01-01\', result: 10 },\n      { label: \'2019-02-01\', result: 40 },\n      { label: \'2019-03-01\', result: 30 },\n      { label: \'2019-04-01\', result: 20 },\n      { label: \'2019-05-01\', result: 40 },\n      { label: \'2019-06-01\', result: 50 },\n    ],\n    [\n      { label: \'2019-01-01\', result: 16 },\n      { label: \'2019-02-01\', result: 46 },\n      { label: \'2019-03-01\', result: 38 },\n      { label: \'2019-04-01\', result: 60 },\n      { label: \'2019-05-01\', result: 70 },\n      { label: \'2019-06-01\', result: 94 },\n    ],\n    [\n      { label: \'2019-01-01\', result: 5 },\n      { label: \'2019-02-01\', result: 4 },\n      { label: \'2019-03-01\', result: 4 },\n      { label: \'2019-04-01\', result: 5 },\n      { label: \'2019-05-01\', result: 6 },\n      { label: \'2019-06-01\', result: 7 },\n    ],\n  ]}\n/>'} __scope={{
      props,
      DefaultLayout,
      StackedBarChart,
      Playground,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
    <StackedBarChart xType='time' yComplement={value => `R$ ${value},00`} title='Custo por manutenção' toolboxTooltip={{
        saveAsImage: 'save'
      }} colors={['#30D2D6', '#9F88FB', '#C5F3C2', '#F09B1B']} tooltip={{
        label: 'Período',
        topResult: 'Preventivas',
        bottomResult: 'Corretivas',
        extraResult: 'Melhorias',
        lineResult: 'Total'
      }} data={[[{
        label: '2019-01-01',
        result: 1
      }, {
        label: '2019-02-01',
        result: 2
      }, {
        label: '2019-03-01',
        result: 4
      }, {
        label: '2019-04-01',
        result: 5
      }, {
        label: '2019-05-01',
        result: 6
      }, {
        label: '2019-06-01',
        result: 7
      }], [{
        label: '2019-01-01',
        result: 10
      }, {
        label: '2019-02-01',
        result: 40
      }, {
        label: '2019-03-01',
        result: 30
      }, {
        label: '2019-04-01',
        result: 20
      }, {
        label: '2019-05-01',
        result: 40
      }, {
        label: '2019-06-01',
        result: 50
      }], [{
        label: '2019-01-01',
        result: 16
      }, {
        label: '2019-02-01',
        result: 46
      }, {
        label: '2019-03-01',
        result: 38
      }, {
        label: '2019-04-01',
        result: 60
      }, {
        label: '2019-05-01',
        result: 70
      }, {
        label: '2019-06-01',
        result: 94
      }], [{
        label: '2019-01-01',
        result: 5
      }, {
        label: '2019-02-01',
        result: 4
      }, {
        label: '2019-03-01',
        result: 4
      }, {
        label: '2019-04-01',
        result: 5
      }, {
        label: '2019-05-01',
        result: 6
      }, {
        label: '2019-06-01',
        result: 7
      }]]} mdxType="StackedBarChart" />
    </Playground>
    <h1 {...{
      "id": "chart-with-3-bars-stacked-line-and-auxresult-on-tooltip"
    }}>{`Chart with 3 bars stacked, line and auxResult on tooltip`}</h1>
    <Playground __position={2} __code={'<StackedBarChart\n  xType=\"time\"\n  yComplement={value => `R$ ${value},00`}\n  title=\"Custo por manutenção\"\n  toolboxTooltip={{ saveAsImage: \'save\' }}\n  colors={[\'#30D2D6\', \'#9F88FB\', \'#C5F3C2\', \'#F09B1B\']}\n  tooltip={{\n    label: \'Período\',\n    topResult: \'Preventivas\',\n    bottomResult: \'Corretivas\',\n    extraResult: \'Melhorias\',\n    auxResult: \'Total real\',\n    lineResult: \'Total\',\n  }}\n  data={[\n    [\n      { label: \'2019-01-01\', result: 1 },\n      { label: \'2019-02-01\', result: 2 },\n      { label: \'2019-03-01\', result: 4 },\n      { label: \'2019-04-01\', result: 5 },\n      { label: \'2019-05-01\', result: 6 },\n      { label: \'2019-06-01\', result: 7 },\n    ],\n    [\n      { label: \'2019-01-01\', result: 10 },\n      { label: \'2019-02-01\', result: 40 },\n      { label: \'2019-03-01\', result: 30 },\n      { label: \'2019-04-01\', result: 20 },\n      { label: \'2019-05-01\', result: 40 },\n      { label: \'2019-06-01\', result: 50 },\n    ],\n    [\n      { label: \'2019-01-01\', result: 16 },\n      { label: \'2019-02-01\', result: 46 },\n      { label: \'2019-03-01\', result: 38 },\n      { label: \'2019-04-01\', result: 60 },\n      { label: \'2019-05-01\', result: 70 },\n      { label: \'2019-06-01\', result: 94 },\n    ],\n    [\n      { label: \'2019-01-01\', result: 5 },\n      { label: \'2019-02-01\', result: 4 },\n      { label: \'2019-03-01\', result: 4 },\n      { label: \'2019-04-01\', result: 5 },\n      { label: \'2019-05-01\', result: 6 },\n      { label: \'2019-06-01\', result: 7 },\n    ],\n    [\n      { label: \'2019-01-01\', result: 0 },\n      { label: \'2019-02-01\', result: 76 },\n      { label: \'2019-03-01\', result: 558 },\n      { label: \'2019-04-01\', result: 10 },\n      { label: \'2019-05-01\', result: 80 },\n      { label: \'2019-06-01\', result: 94 },\n    ],\n  ]}\n/>'} __scope={{
      props,
      DefaultLayout,
      StackedBarChart,
      Playground,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
    <StackedBarChart xType='time' yComplement={value => `R$ ${value},00`} title='Custo por manutenção' toolboxTooltip={{
        saveAsImage: 'save'
      }} colors={['#30D2D6', '#9F88FB', '#C5F3C2', '#F09B1B']} tooltip={{
        label: 'Período',
        topResult: 'Preventivas',
        bottomResult: 'Corretivas',
        extraResult: 'Melhorias',
        auxResult: 'Total real',
        lineResult: 'Total'
      }} data={[[{
        label: '2019-01-01',
        result: 1
      }, {
        label: '2019-02-01',
        result: 2
      }, {
        label: '2019-03-01',
        result: 4
      }, {
        label: '2019-04-01',
        result: 5
      }, {
        label: '2019-05-01',
        result: 6
      }, {
        label: '2019-06-01',
        result: 7
      }], [{
        label: '2019-01-01',
        result: 10
      }, {
        label: '2019-02-01',
        result: 40
      }, {
        label: '2019-03-01',
        result: 30
      }, {
        label: '2019-04-01',
        result: 20
      }, {
        label: '2019-05-01',
        result: 40
      }, {
        label: '2019-06-01',
        result: 50
      }], [{
        label: '2019-01-01',
        result: 16
      }, {
        label: '2019-02-01',
        result: 46
      }, {
        label: '2019-03-01',
        result: 38
      }, {
        label: '2019-04-01',
        result: 60
      }, {
        label: '2019-05-01',
        result: 70
      }, {
        label: '2019-06-01',
        result: 94
      }], [{
        label: '2019-01-01',
        result: 5
      }, {
        label: '2019-02-01',
        result: 4
      }, {
        label: '2019-03-01',
        result: 4
      }, {
        label: '2019-04-01',
        result: 5
      }, {
        label: '2019-05-01',
        result: 6
      }, {
        label: '2019-06-01',
        result: 7
      }], [{
        label: '2019-01-01',
        result: 0
      }, {
        label: '2019-02-01',
        result: 76
      }, {
        label: '2019-03-01',
        result: 558
      }, {
        label: '2019-04-01',
        result: 10
      }, {
        label: '2019-05-01',
        result: 80
      }, {
        label: '2019-06-01',
        result: 94
      }]]} mdxType="StackedBarChart" />
    </Playground>
    <h2 {...{
      "id": "chart-with-2-bars-stacked-with-pareto"
    }}>{`Chart with 2 bars stacked with pareto`}</h2>
    <Playground __position={3} __code={'<StackedBarChart\n  sumDataValues\n  yComplement={value => `R$ ${value},00`}\n  colors={[\'#487086\', \'#87C4CB\', \'#E97551\']}\n  secondYAxisType=\"percent\"\n  tooltip={{\n    label: \'Equipamento\',\n    topResult: \'Aquisição\',\n    bottomResult: \'Manutenção\',\n    lineResult: \'Custo % acumulado\',\n    complement: \'Custo total\',\n  }}\n  data={[\n    [\n      { label: \'a01\', result: 1 },\n      { label: \'a02\', result: 2 },\n      { label: \'a03\', result: 4 },\n      { label: \'a04\', result: 5 },\n      { label: \'a05\', result: 6 },\n      { label: \'a06\', result: 7 },\n      { label: \'a07\', result: 11 },\n      { label: \'a08\', result: 42 },\n      { label: \'a09\', result: 54 },\n      { label: \'a10\', result: 55 },\n      { label: \'a11\', result: 66 },\n      { label: \'a12\', result: 87 },\n      { label: \'a13\', result: 1 },\n      { label: \'a14\', result: 2 },\n      { label: \'a015\', result: 4 },\n      { label: \'a016\', result: 5 },\n      { label: \'a017\', result: 6 },\n      { label: \'a018\', result: 7 },\n      { label: \'a019\', result: 11 },\n      { label: \'a020\', result: 42 },\n      { label: \'a021\', result: 54 },\n      { label: \'a022\', result: 55 },\n      { label: \'a023\', result: 66 },\n      { label: \'a024\', result: 87 },\n    ],\n    [\n      { label: \'a01\', result: 10 },\n      { label: \'a02\', result: 40 },\n      { label: \'a03\', result: 30 },\n      { label: \'a04\', result: 20 },\n      { label: \'a05\', result: 40 },\n      { label: \'a06\', result: 50 },\n      { label: \'a07\', result: 11 },\n      { label: \'a08\', result: 42 },\n      { label: \'a09\', result: 54 },\n      { label: \'a10\', result: 55 },\n      { label: \'a11\', result: 66 },\n      { label: \'a12\', result: 87 },\n      { label: \'a13\', result: 1 },\n      { label: \'a14\', result: 2 },\n      { label: \'a015\', result: 4 },\n      { label: \'a016\', result: 5 },\n      { label: \'a017\', result: 6 },\n      { label: \'a018\', result: 7 },\n      { label: \'a019\', result: 11 },\n      { label: \'a020\', result: 42 },\n      { label: \'a021\', result: 54 },\n      { label: \'a022\', result: 55 },\n      { label: \'a023\', result: 66 },\n      { label: \'a024\', result: 87 },\n    ],\n    [\n      { label: \'a01\', result: 11 },\n      { label: \'a02\', result: 42 },\n      { label: \'a03\', result: 54 },\n      { label: \'a04\', result: 55 },\n      { label: \'a05\', result: 66 },\n      { label: \'a06\', result: 87 },\n      { label: \'a07\', result: 11 },\n      { label: \'a08\', result: 42 },\n      { label: \'a09\', result: 54 },\n      { label: \'a10\', result: 55 },\n      { label: \'a11\', result: 66 },\n      { label: \'a12\', result: 87 },\n      { label: \'a13\', result: 1 },\n      { label: \'a14\', result: 2 },\n      { label: \'a015\', result: 4 },\n      { label: \'a016\', result: 5 },\n      { label: \'a017\', result: 6 },\n      { label: \'a018\', result: 7 },\n      { label: \'a019\', result: 11 },\n      { label: \'a020\', result: 42 },\n      { label: \'a021\', result: 54 },\n      { label: \'a022\', result: 55 },\n      { label: \'a023\', result: 66 },\n      { label: \'a024\', result: 87 },\n    ],\n  ]}\n/>'} __scope={{
      props,
      DefaultLayout,
      StackedBarChart,
      Playground,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
    <StackedBarChart sumDataValues yComplement={value => `R$ ${value},00`} colors={['#487086', '#87C4CB', '#E97551']} secondYAxisType='percent' tooltip={{
        label: 'Equipamento',
        topResult: 'Aquisição',
        bottomResult: 'Manutenção',
        lineResult: 'Custo % acumulado',
        complement: 'Custo total'
      }} data={[[{
        label: 'a01',
        result: 1
      }, {
        label: 'a02',
        result: 2
      }, {
        label: 'a03',
        result: 4
      }, {
        label: 'a04',
        result: 5
      }, {
        label: 'a05',
        result: 6
      }, {
        label: 'a06',
        result: 7
      }, {
        label: 'a07',
        result: 11
      }, {
        label: 'a08',
        result: 42
      }, {
        label: 'a09',
        result: 54
      }, {
        label: 'a10',
        result: 55
      }, {
        label: 'a11',
        result: 66
      }, {
        label: 'a12',
        result: 87
      }, {
        label: 'a13',
        result: 1
      }, {
        label: 'a14',
        result: 2
      }, {
        label: 'a015',
        result: 4
      }, {
        label: 'a016',
        result: 5
      }, {
        label: 'a017',
        result: 6
      }, {
        label: 'a018',
        result: 7
      }, {
        label: 'a019',
        result: 11
      }, {
        label: 'a020',
        result: 42
      }, {
        label: 'a021',
        result: 54
      }, {
        label: 'a022',
        result: 55
      }, {
        label: 'a023',
        result: 66
      }, {
        label: 'a024',
        result: 87
      }], [{
        label: 'a01',
        result: 10
      }, {
        label: 'a02',
        result: 40
      }, {
        label: 'a03',
        result: 30
      }, {
        label: 'a04',
        result: 20
      }, {
        label: 'a05',
        result: 40
      }, {
        label: 'a06',
        result: 50
      }, {
        label: 'a07',
        result: 11
      }, {
        label: 'a08',
        result: 42
      }, {
        label: 'a09',
        result: 54
      }, {
        label: 'a10',
        result: 55
      }, {
        label: 'a11',
        result: 66
      }, {
        label: 'a12',
        result: 87
      }, {
        label: 'a13',
        result: 1
      }, {
        label: 'a14',
        result: 2
      }, {
        label: 'a015',
        result: 4
      }, {
        label: 'a016',
        result: 5
      }, {
        label: 'a017',
        result: 6
      }, {
        label: 'a018',
        result: 7
      }, {
        label: 'a019',
        result: 11
      }, {
        label: 'a020',
        result: 42
      }, {
        label: 'a021',
        result: 54
      }, {
        label: 'a022',
        result: 55
      }, {
        label: 'a023',
        result: 66
      }, {
        label: 'a024',
        result: 87
      }], [{
        label: 'a01',
        result: 11
      }, {
        label: 'a02',
        result: 42
      }, {
        label: 'a03',
        result: 54
      }, {
        label: 'a04',
        result: 55
      }, {
        label: 'a05',
        result: 66
      }, {
        label: 'a06',
        result: 87
      }, {
        label: 'a07',
        result: 11
      }, {
        label: 'a08',
        result: 42
      }, {
        label: 'a09',
        result: 54
      }, {
        label: 'a10',
        result: 55
      }, {
        label: 'a11',
        result: 66
      }, {
        label: 'a12',
        result: 87
      }, {
        label: 'a13',
        result: 1
      }, {
        label: 'a14',
        result: 2
      }, {
        label: 'a015',
        result: 4
      }, {
        label: 'a016',
        result: 5
      }, {
        label: 'a017',
        result: 6
      }, {
        label: 'a018',
        result: 7
      }, {
        label: 'a019',
        result: 11
      }, {
        label: 'a020',
        result: 42
      }, {
        label: 'a021',
        result: 54
      }, {
        label: 'a022',
        result: 55
      }, {
        label: 'a023',
        result: 66
      }, {
        label: 'a024',
        result: 87
      }]]} mdxType="StackedBarChart" />
    </Playground>
    <h2 {...{
      "id": "chart-wit-2-bars-stacked"
    }}>{`Chart wit 2 bars stacked`}</h2>
    <Playground __position={4} __code={'<StackedBarChart\n  sumDataValues\n  showBarLabel\n  barWidth={80}\n  yComplement={value => `R$ ${value},00`}\n  legendType=\"none\"\n  tooltip={{\n    label: \'Criticidade\',\n    topResult: \'Tempo médio em atendimento\',\n    bottomResult: \'Tempo médio em execução\',\n    complement: \'Tempo médio total\',\n  }}\n  data={[\n    [\n      {\n        label: \'Emergencial\',\n        result: 1,\n        style: { color: \'red\', opacity: 0.7 },\n      },\n      { label: \'Alta\', result: 2, style: { color: \'orange\', opacity: 0.7 } },\n      { label: \'Média\', result: 4, style: { color: \'yellow\', opacity: 0.7 } },\n      { label: \'Baixa\', result: 5, style: { color: \'green\', opacity: 0.7 } },\n    ],\n    [\n      { label: \'Emergencial\', result: 10, style: { color: \'red\' } },\n      { label: \'Alta\', result: 40, style: { color: \'orange\' } },\n      { label: \'Média\', result: 30, style: { color: \'yellow\' } },\n      { label: \'Baixa\', result: 20, style: { color: \'green\' } },\n    ],\n  ]}\n/>'} __scope={{
      props,
      DefaultLayout,
      StackedBarChart,
      Playground,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
    <StackedBarChart sumDataValues showBarLabel barWidth={80} yComplement={value => `R$ ${value},00`} legendType='none' tooltip={{
        label: 'Criticidade',
        topResult: 'Tempo médio em atendimento',
        bottomResult: 'Tempo médio em execução',
        complement: 'Tempo médio total'
      }} data={[[{
        label: 'Emergencial',
        result: 1,
        style: {
          color: 'red',
          opacity: 0.7
        }
      }, {
        label: 'Alta',
        result: 2,
        style: {
          color: 'orange',
          opacity: 0.7
        }
      }, {
        label: 'Média',
        result: 4,
        style: {
          color: 'yellow',
          opacity: 0.7
        }
      }, {
        label: 'Baixa',
        result: 5,
        style: {
          color: 'green',
          opacity: 0.7
        }
      }], [{
        label: 'Emergencial',
        result: 10,
        style: {
          color: 'red'
        }
      }, {
        label: 'Alta',
        result: 40,
        style: {
          color: 'orange'
        }
      }, {
        label: 'Média',
        result: 30,
        style: {
          color: 'yellow'
        }
      }, {
        label: 'Baixa',
        result: 20,
        style: {
          color: 'green'
        }
      }]]} mdxType="StackedBarChart" />
    </Playground>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      